import { create } from 'zustand'
import { persist } from 'zustand/middleware'

const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isLoading: false,
      error: null,

      login: async (email, password) => {
        set({ isLoading: true, error: null })
        
        try {
          const apiUrl = import.meta.env.DEV ? 'http://localhost:3001/api/login' : '/api/login'
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
          })

          const data = await response.json()

          if (!response.ok) {
            throw new Error(data.error || 'Error al iniciar sesión')
          }

          set({ 
            user: data.user, 
            token: data.token, 
            isLoading: false,
            error: null 
          })

          return { success: true }
        } catch (error) {
          set({ 
            isLoading: false, 
            error: error.message,
            user: null,
            token: null 
          })
          return { success: false, error: error.message }
        }
      },

      logout: () => {
        set({ user: null, token: null, error: null })
      },

      changePassword: async (currentPassword, newPassword) => {
        const { token } = get()
        set({ isLoading: true, error: null })

        try {
          const apiUrl = import.meta.env.DEV ? 'http://localhost:3001/api/user/change-password' : '/api/user/change-password'
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ currentPassword, newPassword }),
          })

          const data = await response.json()

          if (!response.ok) {
            throw new Error(data.error || 'Error al cambiar contraseña')
          }

          set({ isLoading: false, error: null })
          return { success: true }
        } catch (error) {
          set({ isLoading: false, error: error.message })
          return { success: false, error: error.message }
        }
      },

      clearError: () => set({ error: null }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token 
      }),
    }
  )
)

export { useAuthStore }